<template>
  <modal :show.sync="modal_cart">
    <h4 slot="header" class="text-primary m-0">
      {{ $t("app.modules.modal_car_item_add.title") }}
    </h4>
    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitAddToCart)">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <fg-input
                disabled
                type="text"
                :label="$t('app.modules.complaints.headers.product_description')"
                v-model="item.descripcion"
              >
              </fg-input>
            </div>
          </div>
        </div>

         <!--
         <div class="row" style="margin-top: 15px">
          <div class="col-12">
            <div class="form-group">
              <label>{{ $t("app.modules.product_family_detail.headers.mailing_address") }}</label>

              <el-select
                :placeholder="$t('app.modules.product_family_detail.headers.select_address')"
                size="large"
                v-model="item.direccionId"
                @change="changeOption"
              >
                <el-option
                  v-for="(ad, index) in addresses"
                  :key="'address-'+index"
                  :label=" ad.calle + ' '+ ad.estado + ' '+ ad.pais + ' - ' + ad.razonSocial"
                  :value="ad.idDireccion"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        -->

        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <fg-input
                type="number"
                :label="$t('app.modules.product_family_detail.headers.quantity') + ' '+ (item.unidad.length > 0 ? '('+item.unidad+')' : '')"
                v-model="item.quantity"
                min="1"
                :error="item.quantity < 1 ? $t('app.product_suggestions.quantity_required') : false"
              >
              </fg-input>
            </div>
          </div>

          <!--          
          <div class="col-6">
            <div class="form-group">
              <label>{{ $t('app.modules.product_family_detail.headers.delivery_date') }}</label>
              <el-date-picker v-model="item.delivery_date" format="dd-MM-yyyy" type="date"/>
            </div>
          </div>
          -->

        </div>



        <div class="row" style="margin-top: 15px">
          <div class="col-12">
            <div class="form-group">
              <label>{{ $t('app.modules.product_family_detail.headers.price') }}</label>
              <h3>{{ priceTitle }}</h3>
            </div>
          </div>
        </div>

        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left" @click.native="cancelAdd" >{{ $t("app.buttons.cancel") }}</n-button>
          <!--<n-button v-if="item.price > 0 && item.quantity > 0"  native-type="button" @click.native="addProducto" type="primary">{{ $t("app.buttons.add") }}</n-button>-->
          <n-button v-if="item.quantity > 0"  native-type="button" @click.native="addProducto" type="primary">{{ $t("app.buttons.add") }}</n-button>
        </div>


        <!--<div class="row" v-for="(item) in detallPedidos" :key="item.idDetallePedido">
          <card class="box-card">
          <div class="col-md-12 col-sm-12">
           <fg-input
              disabled
              type="text"
              :label="$t('app.modules.complaints.headers.product_description')"
              v-model="item.descripcionProducto"
            >
            </fg-input>
          </div>
          <div class="col-md-12 col-sm-12">
            <span class="demonstration">{{
                $t("app.modules.modal_car_item_add.headers.quantity")
              }}</span>
              <div>
            <el-input-number size="medium" v-model="item.cantidad" controls-position="right" :min="1" ></el-input-number>
              </div>
          </div>
          <div class="col-md-12 col-sm-12">
            <ValidationProvider
              :name="'requiredDatetime-' +item.idDetallePedido"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <span class="demonstration">{{
                $t("app.modules.modal_car_item_add.headers.delivery_date")
              }}</span>
              <el-date-picker
                :hasSuccess="passed"
                :picker-options="pickerOptions"
                v-model="item.fechaEntrega"
                type="date"
                :placeholder="
                  $t('app.modules.modal_car_item_add.headers.delivery_date')
                "
              >
              </el-date-picker>
              <div
                v-if="failed"
                class="text-danger invalid-feedback"
                style="display: block;"
              >
                {{ required_text }}
              </div>
            </ValidationProvider>
          </div>
          </card>
        </div>
      <div
          slot="footer"

          class="text-right"
        >
        <n-button class="pull-left" @click.native="cancelAdd" >{{
          $t("app.buttons.cancel")
        }}</n-button>
        <n-button native-type="submit" type="primary">{{
           $t("app.modules.modal_car_item_add.headers.add")
        }}</n-button>
      </div>-->
    </form>
    </ValidationObserver>
  </modal>
</template>

<script>
import { integer } from 'vee-validate/dist/rules'
import {getResponse} from "@/util/utilities";

export default {
  components: {
  },
  computed: {
    priceTitle() {
      return this.item.price === 0 ? this.$t('app.modules.product_family_detail.errors.not_available') : this.item.price + " " + this.item.moneda + "/" + this.item.unidad;
    },
  },
  data(){
    return{
      //detallPedidos: [],
      //productosValidos: [],
      //required_text: this.$t("app.general.required"),
      /*pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },*/
      modal_cart: false,
      item: {
        descripcion: "",
        quantity: 1,
        delivery_date: "",
        unidad: "",
        moneda: "",
        direccionId: "",
        price: 0,
        productoId: 0,
        origen_creacion: 0,
        material: ""
      },
      addresses: []
    }
  },
  async mounted(){
    EventBus.$on("show-add.item-cart", async item => {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      console.log("en add de item --> " + JSON.stringify(item));
      this.item.material= item.producto.codigoProducto;
      this.item.descripcion = item.producto.textoBreveMaterial;
      this.item.productoId = item.producto.idProducto;
      this.item.delivery_date = item.delivery_date ? this.$moment(item.delivery_date, 'DD-MM-YYYY') : '';
      this.item.origen_creacion = item.origenCreacion;
      await this.getAddresses();
      this.modal_cart = true;

      this.$swal.close();
    });
  },
  methods:{
    async getAddresses(){
      let paramClient = {
        clienteId: this.$store.state.user.idClienteSAP
      };
      let requestDir = await this.$http.post(route("Clientes/getDireccionesByCliente"), paramClient);
      let responseDir = getResponse(requestDir);

      if(responseDir != null){
        this.addresses = responseDir.direcciones;
      }
    },
    changeOption(){
      this.loadPrecio();
    },
    async loadPrecio(){
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      let param = {
        direccionId: this.item.direccionId,
        productoId: this.item.productoId,
        clienteIdSAP: this.$store.state.user.idClienteSAP
      };

      this.item.price = 0;
      this.item.moneda = "";
      this.item.unidad = "";
      this.item.idProductoCliente = 0;

      if(!param.direccionId || !param.productoId || !param.clienteIdSAP) {
        this.$swal.close();
        return
      }

      let request = await this.$http.put(route("Productos/getPrecioByProducto"), param);
      let response = getResponse(request, null);

      if(response && response.productos.length > 0){
        let producto = response.productos[0];
        this.item.price = producto.precioUnitario;
        this.item.moneda = producto.moneda;
        this.item.unidad = producto.unidadMedida;
        this.item.idProductoCliente = producto.idProductoCliente;
      }

      this.$swal.close();
    },
    addProducto(){
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      try{

        var fechatest = new Date();
        fechatest.setDate(fechatest.getDate() + 30);

        //para obtener el id de Producto



        let payload = {idProductoCliente: this.item.idProductoCliente, cantidad: this.item.quantity, fechaEntrega: fechatest, material: this.item.material, origenCreacion: this.item.origen_creacion}
        console.log("Antes del add-to-cart ---> "+JSON.stringify(payload));
        //if(!payload.idProductoCliente) throw new Error(this.$t("app.modules.product_family_detail.errors.no_client"));
        if(!payload.cantidad) throw new Error(this.$t("app.modules.product_family_detail.errors.no_quantity"));
        
        //if(!payload.fechaEntrega) throw new Error(this.$t("app.modules.product_family_detail.errors.no_delivery_date"));

        EventBus.$emit("add-to-cart", payload);

        this.cancelAdd();
      }
      catch (e){
        this.notifyMessage("danger", e.message);
      }
      finally {
        this.$swal.close();
      }
    },
    cancelAdd(){
      this.item = {
          descripcion: "",
          quantity: 1,
          delivery_date: "",
          unidad: "",
          moneda: "",
          direccionId: "",
          price: 0,
          productoId: 0
      }
      this.modal_cart = false;
      this.addresses = [];
    }
  }
}
</script>
